
import React, { useEffect, useState } from 'react';
import { myorders, fetchPaymentDetails } from './action';
import {
  CheckCircleIcon,
  ChevronDown,
  ChevronUp,
  MinusCircleIcon,
  PackageIcon,
  ShoppingCart,
  HomeIcon,
  List,
  LayoutGrid
} from 'lucide-react';
import axios from 'axios';
import { VerifyToken } from '../../MiddleWare/verifyToken';
import { useNavigate } from 'react-router-dom';
const THIRTY_MINUTES = 30 * 60 * 1000;
const OrderDashboard = () => {
  const [openOrderId, setOpenOrderId] = useState(null);
  const [OrdersData, setOrderData] = useState([]);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isGridView, setIsGridView] = useState(true);
  const [payments, setPayments] = useState([]);
  const [invoiceRequested, setInvoiceRequested] = useState({});
  const [invoiceRequestTimes, setInvoiceRequestTimes] = useState({});
  const navigate = useNavigate();

  VerifyToken();

  useEffect(() => {
    const fetchpayment = async () => {
      const paymentData = await fetchPaymentDetails();
      setPayments(paymentData || []);
      // console.log("Fetched Payments:", paymentData); 
    };

    fetchpayment();
  }, []);






  useEffect(() => {
    const fetchOrders = async () => {
      const orderData = await myorders();
      setOrderData(orderData);
    };
    fetchOrders();
    const storedTimes = JSON.parse(localStorage.getItem('invoiceRequestTimes') || '{}');
    setInvoiceRequestTimes(storedTimes);
  }, []);

  const handleViewHome = () => {
    navigate('/shop');
  };
  const handleInvoiceRequest = async (orderId) => {
    const currentTime = new Date().getTime();
    const lastRequestTime = invoiceRequestTimes[orderId] || 0;
    const timeElapsed = currentTime - lastRequestTime;

    if (timeElapsed < THIRTY_MINUTES) {
      const remainingSeconds = Math.ceil((THIRTY_MINUTES - timeElapsed) / 1000);
      setError(`Please wait for ${remainingSeconds} seconds before requesting another invoice for this order.`);
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await axios.post(`${process.env.REACT_APP_URL}/api/processOrder/${orderId}`,
        { orderId },
        { headers: { token: `${token}` } }
      );
      setInvoiceRequested(prev => ({ ...prev, [orderId]: true }));
      setSuccess(`Invoice for order ${orderId} has been requested. You will receive it via email shortly.`);

      // Update the request time
      const newRequestTimes = { ...invoiceRequestTimes, [orderId]: currentTime };
      setInvoiceRequestTimes(newRequestTimes);
      localStorage.setItem('invoiceRequestTimes', JSON.stringify(newRequestTimes));

      // Set a timeout to enable the button after 1 minute
      setTimeout(() => {
        setInvoiceRequested(prev => ({ ...prev, [orderId]: false }));
      }, THIRTY_MINUTES);
    } catch (error) {
      console.error('Error requesting invoice:', error);
      setError(`Failed to request invoice for order ${orderId}. Please try again later.`);
    }
  };

  const isInvoiceRequestDisabled = (orderId) => {
    const lastRequestTime = invoiceRequestTimes[orderId] || 0;
    const timeElapsed = new Date().getTime() - lastRequestTime;
    return timeElapsed < THIRTY_MINUTES;
  };

  console.log("data", OrdersData)
  const formattedOrders = OrdersData.map((order) => {
    const formattedItems = order.order_details.map((item) => {
      let itemAmount;

      const selectedPrice = item.selectedPack ? item[item.selectedPack] : null;
      if (selectedPrice) {
        itemAmount = item.quantity * selectedPrice;
      }
      return {
        name: item.ItemName,
        quantity: item.quantity,
        amount: itemAmount,
        selectedPack: item.selectedPack,
      };
    });
    const paymentDetails = payments.find(payment => payment.paymentid === order.paymentid);
    const date = new Date(order.processing_date);
    const formattedDate = date.toLocaleDateString('en-GB');
    return {
      id: order.order_generated_id,
      amount: order.total_amount,
      items: formattedItems,
      status: order.delivery_status,
      date: formattedDate,
      finalinvoice: order.finalinvoicevalue,
      couponcode: order.couponcode,
      discount: order.discount,
      merchantreferenceid: paymentDetails?.merchantreferenceid || null,
      phonepereferenceid: paymentDetails?.phonepereferenceid || null,
      paymenttype: paymentDetails?.paymenttype || null,

    };
  });


  const handleOrderClick = (order) => {
    setOpenOrderId(openOrderId === order.id ? null : order.id);
  };

  const renderProgressIcons = (progress) => {
    const stages = ['Accepted', 'Shipped', 'Delivered'];
    const activeIndex = stages.indexOf(progress);

    return (
      <div className="flex justify-between items-center w-full max-w-md mx-auto mt-2">
        {stages.map((stage, index) => (
          <div key={stage} className="flex flex-col items-center relative">
            {index > 0 && (
              <div className={`absolute w-full h-0.5 right-1/2 top-3 -z-10 
                ${index <= activeIndex ? 'bg-green-500' : 'bg-gray-300'}`}
              />
            )}
            {index <= activeIndex ? (
              <CheckCircleIcon className="text-green-500 h-8 w-8 mb-1 transition-transform duration-200 transform hover:scale-110" />
            ) : (
              <MinusCircleIcon className="text-gray-300 h-8 w-8 mb-1 transition-transform duration-200 transform hover:scale-110" />
            )}
            <span className={`text-sm font-medium ${index <= activeIndex ? 'text-green-600' : 'text-gray-400'}`}>
              {stage.charAt(0).toUpperCase() + stage.slice(1)}
            </span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-red-600 via-orange-500 to-yellow-400 p-8 shadow-lg">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <HomeIcon
            className="h-8 w-8 text-white cursor-pointer hover:scale-110 transition-transform"
            onClick={handleViewHome}
          />
          <div className="text-center flex-grow">
            <h1 className="text-4xl font-bold text-white mb-2">My Orders</h1>
            <p className="text-white text-lg">Track and manage your orders</p>
          </div>
          <div className="w-8" />
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        {/* Alerts */}
        {error && (
          <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded shadow-sm" role="alert">
            <p className="font-bold">Error</p>
            <p>{error}</p>
          </div>
        )}

        {success && (
          <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-6 rounded shadow-sm" role="alert">
            <p className="font-bold">Success</p>
            <p>{success}</p>
          </div>
        )}

        {/* Orders List */}
        <div className="space-y-6">
          {formattedOrders.length > 0 ? formattedOrders.map((order) => (
            <div
              key={order.id}
              className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl"
            >
              <div className="p-6 border-b border-gray-100">
                <div className="flex justify-between items-center">
                  <div className="flex items-center space-x-3">
                    <PackageIcon className="h-6 w-6 text-orange-500" />
                    <h3 className="text-xl font-semibold text-gray-800">Order #{order.id}</h3>
                  </div>
                  <div className="flex items-center space-x-4">
                    {order.discount ? (
                      <div>
                        <p className="text-sm line-through text-gray-500">Total: ₹{order.amount}</p>
                        <p className="text-xl font-bold text-orange-600">Final: ₹{order.finalinvoice}</p>
                      </div>
                    ) : (
                      <p className="text-xl font-bold text-orange-600">Total: ₹{order.amount}</p>
                    )}
                    <button
                      onClick={() => handleOrderClick(order)}
                      className="p-2 hover:bg-orange-100 rounded-full transition-colors duration-200"
                    >
                      {openOrderId === order.id ? (
                        <ChevronUp className="h-6 w-6 text-orange-500" />
                      ) : (
                        <ChevronDown className="h-6 w-6 text-orange-500" />
                      )}
                    </button>
                  </div>
                </div>

                <div className="mt-6">
                  {renderProgressIcons(order.status)}
                </div>
              </div>

              {/* Order Details */}
              {openOrderId === order.id && (
                <div className="bg-orange-50 p-6 border-t border-orange-100">
                  <div className="flex justify-between mb-4">
                    <h4 className="text-lg font-semibold text-gray-800">Order Details</h4>
                    <div className="flex gap-4">
                      <button
                        onClick={() => handleInvoiceRequest(order.id)}
                        disabled={isInvoiceRequestDisabled(order.id)}
                        className={`px-4 py-2 rounded-lg font-medium transition-colors ${isInvoiceRequestDisabled(order.id)
                          ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                          : 'bg-orange-500 text-white hover:bg-orange-600'
                          }`}
                      >
                        {isInvoiceRequestDisabled(order.id) ? 'Invoice Requested' : 'Request Invoice'}
                      </button>
                      <button
                        onClick={() => setIsGridView(!isGridView)}
                        className="flex items-center gap-2 px-4 py-2 rounded-lg bg-orange-100 text-orange-600 hover:bg-orange-200 transition-colors"
                      >
                        {isGridView ? <List className="h-5 w-5" /> : <LayoutGrid className="h-5 w-5" />}
                        <span>{isGridView ? 'List View' : 'Grid View'}</span>
                      </button>
                    </div>
                    </div>

                    <div className="bg-white p-4 rounded-lg shadow-sm mb-4">
                      <h5 className="font-semibold text-orange-600 mb-2">Payment Details</h5>
                      <p className="text-sm text-gray-600"><strong>Payment Type: </strong>{order.paymenttype || 'N/A'}</p>
                      <p className="text-sm text-gray-600"><strong>Merchant Reference ID: </strong>{order.merchantreferenceid || 'N/A'}</p>
                      <p className="text-sm text-gray-600"><strong>PhonePe Reference ID: </strong>{order.phonepereferenceid || 'N/A'}</p>

                    </div>

                    {/* Coupon Details (Only if coupon is applied) */}
                    {order.couponcode && (
                      <div className="bg-white p-4 rounded-lg shadow-sm mb-4">
                        <h5 className="font-semibold text-orange-600 mb-2">Coupon Details</h5>
                        <p className="text-sm text-gray-600"><strong>Coupon Code: </strong> {order.couponcode}</p>
                        <p className="text-sm text-gray-600"><strong>Discount Applied: </strong> {order.discount} %</p>
                        <p className="text-sm text-gray-600"><strong>Total Amount: </strong> ₹{order.amount}</p>
                        <p className="text-sm text-gray-600"><strong>Amount Paid: </strong> ₹{order.finalinvoice}</p>
                      </div>
                    )}

                    {isGridView ? (
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {order.items.map((item, index) => (
                          <div key={index} className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-all duration-200">
                            <div className="flex justify-between items-start">
                              <div className="space-y-2">
                                <h5 className="font-semibold text-gray-800">{item.name}</h5>
                                <p className="text-sm text-gray-600">Quantity: {item.quantity}</p>
                                <p className="text-sm text-gray-600">Pack: {item.selectedPack}</p>
                              </div>
                              <p className="font-semibold text-orange-600">₹{item.amount}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="flex flex-col gap-4">
                        {order.items.map((item, index) => (
                          <div key={index} className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-all duration-200">
                            <div className="flex justify-between items-start">
                              <div className="space-y-2">
                                <h5 className="font-semibold text-gray-800">{item.name}</h5>
                                <p className="text-sm text-gray-600">Quantity: {item.quantity}</p>
                                <p className="text-sm text-gray-600">Pack: {item.selectedPack}</p>
                              </div>
                              <p className="font-semibold text-orange-600">₹{item.amount}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
)}


                </div>
              )) : (
              <div className="text-center py-16 bg-white rounded-xl shadow-md">
                <PackageIcon className="h-20 w-20 text-gray-400 mx-auto mb-4" />
                <h3 className="text-xl font-medium text-gray-900 mb-2">No orders found</h3>
                <p className="text-gray-500 mb-6">Start shopping to see your orders here.</p>
                <button
                  onClick={handleViewHome}
                  className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-medium rounded-lg hover:bg-orange-600 transition-colors"
                >
                  <ShoppingCart className="mr-2 h-5 w-5" />
                  Start Shopping
                </button>
              </div>
          )}
            </div>
      </div>
      </div>
      );
};

      export default OrderDashboard;
